import { render, staticRenderFns } from "./ProductModelFormModal.vue?vue&type=template&id=16b0edee&scoped=true&"
import script from "./ProductModelFormModal.vue?vue&type=script&lang=js&"
export * from "./ProductModelFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b0edee",
  null
  
)

export default component.exports